// extracted by mini-css-extract-plugin
export var addViewLink = "_9-2";
export var availabilityIcon = "_9-17";
export var availabilitySelectionIcon = "_9-16";
export var backButton = "_9-3";
export var backIcon = "_9-10";
export var conversationCount = "_9-4";
export var dragHandle = "_9-6";
export var dropdown = "_9-f";
export var dropdownIcon = "_9-8";
export var dropdownOption = "_9-7";
export var dropdownTriangle = "_9-e";
export var expand = "_9-g";
export var folder = "_9-j";
export var folderItem = "_9-d";
export var icon = "_9-9";
export var iconRow = "_9-a";
export var image = "_9-b";
export var logo = "_9-c";
export var navContainer = "_9-i";
export var navigationFooter = "_9-h";
export var pageShell = "_9-0";
export var pageShellWms = "_9-1";
export var placeholderAvailable = "_9-12";
export var placeholderBox = "_9-15";
export var placeholderBusy = "_9-14";
export var placeholderUnavailable = "_9-13";
export var profile = "_9-l";
export var profileContainer = "_9-n";
export var profileDropdown = "_9-o";
export var profileImage = "_9-m";
export var profileMain = "_9-p";
export var profileSubtitle = "_9-r";
export var profileTitle = "_9-q";
export var reorderIcon = "_9-s";
export var sentLine = "_9-v";
export var settingsHeader = "_9-t";
export var sidenavTextColor = "_9-z";
export var spamLine = "_9-u";
export var subitemWithTag = "_9-5";
export var supportItems = "_9-k";
export var teamText = "_9-11";
export var viewLine = "_9-y";
export var viewLineButton = "_9-x";
export var viewLineButtons = "_9-w";